import * as actionTypes from "./actionTypes";

const initialState = {
    auth: null,
    authToken: ""
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_AUTH_DATA:
            return {
                ...state,
                auth: action.payload.data,
                authToken:action.payload.token
            };
        case actionTypes.UPDATE_REDUCER:
            return {
                ...state,
                [action.payload.key]: action.payload.data,
            };
        case actionTypes.RESET:
            return {
                ...initialState
            };
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default reducer;
